<template>
  <div>
    <v-layout class="top_brd_crumbs_wrap mt-20">
      <v-flex class="brd_crumbs">
        <v-btn
          text
          :class="{ 'actv' : view == 'R'}"
          @click="view = 'R'"
        >{{ $t('myapplication.myapplication_details.fields.receipt') }}</v-btn>
        <v-btn
          text
          :class="{ 'actv' : view == 'I'}"
          @click="view = 'I'"
        >{{ $t('myapplication.myapplication_details.fields.invoice') }}</v-btn>
      </v-flex>
      <v-flex class="label ft-size12">
        <label class="top_comp_title">
        {{$t('myapplication.myapplication_details.fields.due_date')}}
        </label>
      </v-flex>
      <v-flex class="content bd_none pr-3">
        <div class="input_text_type_basic2 w-150">
          <v-menu
            v-model="startDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            min-width="150"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                hide-details
                outlined
                solo
                dense
                flat
                readonly
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar"
                class="date_type"
                clearable
                v-model="search.search_start_date"
                @click:append="startDateMenu = true"
              ></v-text-field>
            </template>
            <v-date-picker v-model="startDate" :max="$moment(search.search_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD')" no-title @input="fnSetStartDate()"></v-date-picker>
          </v-menu>
        </div>
      </v-flex>
      <v-spacer class="hidden_lr2">~</v-spacer>
      <v-flex class="content bd_none pl-3 pr-3">
        <div class="input_text_type_basic2 w-150">
          <v-menu
            v-model="endDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                hide-details
                outlined
                solo
                dense
                flat
                readonly
                v-model="search.search_end_date"
                v-on="on"
                v-bind="attrs"
                append-icon="mdi-calendar"
                class="date_type"
                clearable
                @click:append="endDateMenu = true"
              ></v-text-field>
            </template>
            <v-date-picker v-model="endDate" :min="$moment(search.search_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD')" no-title @input="fnSetEndDate()"></v-date-picker>
          </v-menu>
        </div>
      </v-flex>
      <v-btn class="search_btn" rounded @click="fnGetPaymentList()">{{ $t('common.button.search') }}</v-btn>
    </v-layout>
    <v-row class="ma-0 mt-25">
      <v-col class="pa-0">
        <v-data-table
          :headers="$getHeaderType1(headerTxt, headers)"
          :items="receiptList"
          hide-default-footer
          disable-pagination
          disable-sort
          class="new__type__table"
          :mobile-breakpoint="MobileBreakPoint"
          v-show="view == 'R'"
        >
          <template v-slot:item="{ item, index }">
            <tr @click="fnGetReceipt(item)">
              <td>{{ index + 1 }}</td>
              <td>{{ item.application_no }}</td>
              <td>{{ item.receipt_no }}</td>
              <td>{{ item.due_date }}</td>
              <td>{{ item.paid_date }}</td>
              <td>{{ $vuetify.rtl ? item.fee_config_name_ar : item.fee_config_name_en }}</td>
              <td>{{ item.total_amount | comma }}</td>
            </tr>
          </template>
        </v-data-table>

        <v-data-table
          :headers="$getHeaderType1(headerTxt, headers)"
          :items="invoiceList"
          hide-default-footer
          disable-pagination
          disable-sort
          class="new__type__table"
          v-show="view == 'I'"
        >
          <template v-slot:item="{ item, index }">
            <tr @click="fnShowInvoice(item.payment_item_seq)">
              <td>{{ index + 1 }}</td>
              <td>{{ item.application_no }}</td>
              <td>{{ item.receipt_no }}</td>
              <td>{{ item.due_date }}</td>
              <td>{{ item.paid_date }}</td>
              <td>{{ $vuetify.rtl ? item.fee_config_name_ar : item.fee_config_name_en }}</td>
              <td>{{ item.total_amount | comma }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <p class="table_foot_title">{{ $t('myapplication.myapplication_details.fields.foot_title') }}</p>

    <DialogInvoice
      :prop_dialog_invoice.sync="dialog_invoice"
      :prop_invoiceList.sync="invoicePopupList"
      :receipt_no.sync="receipt_no"
      :query="$route.query"
      @close="fnCloseDialogInvoice"
      @error="fnSetDialog">
    </DialogInvoice>

    <DialogReceipt
      :prop_dialog_receipt.sync="dialog_receipt"
      :prop_receipt.sync="receipt"
      @close="fnCloseDialogReceipt">
    </DialogReceipt>
  </div>
</template>
<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import store from '@/store'
import DialogInvoice from '@/components/layout/DialogInvoice'
import DialogReceipt from '@/components/layout/DialogReceipt'

export default {
  props: {
    seq: String,
    filing_date: String
  },
  components: {
    DialogInvoice,
    DialogReceipt,
  },
  data () {
		return {
      MobileBreakPoint:0,
      id: 'MyApplicationPayment',
      view : 'R',

      years : [],
      months : [],
      days : [],

      startDateMenu: false,
      startDate: '',
      endDateMenu: false,
      endDate: '',

      search : {
        search_start_date : '',
        search_end_date : ''
      },
      receipt_no: '',
      headerTxt : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'invoice_no','receipt_no','due_date','receipt_date','fee_name','amount' ]
      },
      headers: [
        { text: '#', align: 'left', width: 50},
        { text: this.$t('myapplication.myapplication_details.fields.invoice_no'), align: 'center', width : '12%' },
        { text: this.$t('myapplication.myapplication_details.fields.receipt_no'), align: 'center', width : '12%' },
        { text: this.$t('myapplication.myapplication_details.fields.due_date'), align: 'center', width : '12%' },
        { text: this.$t('myapplication.myapplication_details.fields.receipt_date'), align: 'center', width : '12%' },
        { text: this.$t('myapplication.myapplication_details.fields.fee_name'), align: 'center' },
        { text: this.$t('myapplication.myapplication_details.fields.amount'), align: 'center', width: '12%' },
      ],
      receiptList : [],
      invoiceList : [],

      // 모달
      selected: [], // 필요없어지거나 화면 로직 변경 필요
      receipt: {},
      dialog_invoice: false,
      dialog_receipt: false,

      invoicePopupList: [],

      invoiceHeaderAr: [
        { text: '#', align: 'center', value: 'no', width: '50px', class: 'data_table_header'},
        { text: 'Descriptions', align: 'center', value: 'name_ar', width: '50%', class: 'data_table_header' },
        { text: 'Invoice Date', align: 'center', value: 'issued_date', class: 'data_table_header'},
        { text: 'Qty', align: 'center', value: 'qty', class: 'data_table_header'},
        { text: 'Rate', align: 'center', value: 'amount', class: 'data_table_header'},
        { text: 'Late Charge', align: 'center', value: 'late_charge_amount', class: 'data_table_header'},
        { text: 'Amount', align: 'center', value: 'total_amount', class: 'data_table_header'}
      ],

      invoiceHeaderEn: [
        { text: '#', align: 'center', value: 'no', width: '50px', class: 'data_table_header'},
        { text: 'Descriptions', align: 'center', value: 'name_en', width: '50%', class: 'data_table_header'},
        { text: 'Invoice Date', align: 'center', value: 'issued_date', class: 'data_table_header'},
        { text: 'Qty', align: 'center', value: 'qty', class: 'data_table_header'},
        { text: 'Rate', align: 'center', value: 'amount', class: 'data_table_header'},
        { text: 'Late Charge', align: 'center', value: 'late_charge_amount', class: 'data_table_header'},
        { text: 'Amount', align: 'center', value: 'total_amount', class: 'data_table_header'}
      ],

      payment: {
        access_code: process.env.VUE_APP_ACCESS_CODE,
        merchant_name: process.env.VUE_APP_MERCHANT_NAME,
        merchant_id: process.env.VUE_APP_MERCHANT_ID,
        payment_url: process.env.VUE_APP_PAYMENT_URL,
        return_url: '',
        version: '1',
        command: 'pay',
        currency: 'EGP',
        locale: 'en',
        secureHash: '',
        transaction_id: null
      },

      result: {
        message: '',
        transactionNo: null,
        txnResponseCode: null
      },

      invoice_seq : null

    }
  },
  computed : {
    totalAmount() {
      let amount = 0
      this.invoicePopupList.forEach(item => {
        amount += item.total_amount
      })
      return amount * 100
    }
  },
  filters:{
    comma(val){
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  mounted(){
    this.fnInit()
  },
  methods : {
    fnInit(){
      this.fnGetPaymentList()
    },
    fnGetPaymentList(){
      this.receiptList = []
      this.invoiceList = []

      requestApi({
        url: '/applications/' + this.seq + '/payments',
        method: 'GET',
        data : this.search,
        callback: (res) => {
          if (res.res_code === '200') {
            res.data.list.forEach(item => {
              if(item.ind_paid == 'Y'){
                this.receiptList.push(item)
              }else{
                this.invoiceList.push(item)
              }
            })
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPaymentList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnShowInvoice(seq){
      this.invoice_seq = seq
      requestApi({
        url: '/applications/'+ this.seq +'/invoices?seqs=' + seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = i + 1
            }
            this.invoicePopupList = res.data.list
            this.dialog_invoice = true
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnShowInvoice(seq)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetReceipt(item) {
      if (!item.payment_history_seq || !item.payment_item_seq) {
        return
      }

      this.receipt = {}
      let params = {
        payment_history_seq: item.payment_history_seq,
        payment_item_seq: item.payment_item_seq
      }
      requestApi({
         url: (item.gubun === 'fee') ? '/applications/'+ this.seq +'/receipt': '/egpo/receivings/annualfee/receipt',
        method: 'GET',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.receipt = res.data
            this.dialog_receipt = true
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt(item)
              })
            } else {
              store.dispatch('SetInitRequestApi')
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnCloseDialogInvoice() {
      this.dialog_invoice = false;
    },

    fnCloseDialogReceipt() {
      this.dialog_receipt = false;
    },

    fnSetDialog(option) {
      this.$router.push(option.path)
      eventBus.$emit('SHOW_DIALOG', option)
    },
    fnSetStartDate(){
      this.startDateMenu = false
      this.search.search_start_date = this.$moment(this.startDate).format('DD/MM/YYYY')
    },
    fnSetEndDate(){
      this.endDateMenu = false
      this.search.search_end_date = this.$moment(this.endDate).format('DD/MM/YYYY')
    },

  }
}
</script>